import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = [{
  title: 'Preparar un mes de cenas en solo 4 horas:',
  description: 'Imagina usar una sola tarde para comprar tu libertad de los próximos 30 días.'
}, {
  title: 'Activar cenas frescas en 10 minutos:',
  description: 'No son sobras recalentadas. Gracias al Escudo de Frescura, la comida se cocina por primera vez cuando tú decides servirla.'
}, {
  title: 'Silenciar la pregunta "¿Qué hay de cenar?":',
  description: 'La respuesta ya está en tu congelador, lista para ir al horno o a la olla sin que tú tengas que picar ni un diente de ajo.'
}];
export const SolutionBenefits = () => {
  return <section className="bg-gray-50 px-4 py-8 md:py-16 lg:px-8" data-id="element-236">
      <div className="mx-auto max-w-4xl" data-id="element-237">
        <div className="rounded-3xl bg-white p-8 shadow-xl md:p-12" data-id="element-238">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-8 text-center" data-id="element-239">
            <h2 className="font-serif text-3xl font-bold text-terracotta md:text-4xl" data-id="element-240">
              El Protocolo de Cenas de Paz
            </h2>
            <p className="mt-4 font-serif text-2xl italic text-text-dark md:text-3xl" data-id="element-241">
              La cena finalmente es fácil (y sabe a alta cocina)
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mb-8 text-center text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-242">
            He diseñado este sistema para que sea el último "recetario" que
            compres en tu vida. No es una lista de ingredientes; es el mapa
            exacto para que dejes de ser una prisionera de tu estufa.
          </motion.p>

          <p className="mb-6 text-center text-lg font-bold text-text-dark" data-id="element-243">
            Con este protocolo vas a lograr:
          </p>

          <ul className="space-y-6" data-id="element-244">
            {benefits.map((benefit, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start space-x-4" data-id="element-245">
                <CheckCircle2 className="mt-1 h-6 w-6 flex-shrink-0 text-terracotta" data-id="element-246" />
                <span className="text-lg text-text-dark md:text-xl" data-id="element-247">
                  <strong data-id="element-248">{benefit.title}</strong> {benefit.description}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
};